var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collections center-wrapper"},[_c('h3',[_vm._v("OUR COLLECTIONS")]),_c('div',{staticClass:"tiles-wrapper"},_vm._l((_vm.categoriesList),function(item){return _c('CollectionTile',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }